const filterNonAdminUsers = (roles, allUsers) => {
  const filteredUsers = allUsers.filter((user) => {
    return user?.Attributes?.find((attribute) => attribute.Name === 'custom:role')?.Value !== roles.ADMINS
  })

  return filteredUsers
}

export default filterNonAdminUsers
